// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tw-color-readout_readout_NZLGR {\n  width: 28px;\n  height: 16px;\n  text-align: center;\n  -moz-appearance: textfield;\n  font: inherit;\n  font-weight: bold;\n}\n[dir=\"ltr\"] .tw-color-readout_readout_NZLGR {\n  margin-left: 10px;\n}\n[dir=\"rtl\"] .tw-color-readout_readout_NZLGR {\n  margin-right: 10px;\n}\n.tw-color-readout_readout_NZLGR::-webkit-outer-spin-button,\n.tw-color-readout_readout_NZLGR::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"readout": "tw-color-readout_readout_NZLGR"
};
module.exports = exports;
